import AbstractEntity from "../AbstractEntity";

export default class Intervention extends AbstractEntity {
    static STATUS_IN_PROGRESS = 0;
    static STATUS_COMPLETED = 1;
    static STATUS_ABORTED = 2;

    static STEP_INITIALIZED = 0;
    static STEP_QUOTATION_APPOINTMENT = 1;
    static STEP_TRAVEL = 2;
    static STEP_PICTURE_BEFORE = 3;
    static STEP_QUOTATION = 4;
    static STEP_QUOTATION_FAIRFAIR_VALIDATION = 5;
    static STEP_QUOTATION_PRESCRIBER_VALIDATION = 6;
    static STEP_QUOTATION_SIGNATURE = 7;
    static STEP_WORKS_APPOINTMENT = 8;
    static STEP_WORKS = 9;
    static STEP_PICTURE_AFTER = 10;
    static STEP_REPORT_COMPLETION = 11;
    static STEP_REPORT_COMPLETION_SIGNATURE = 12;

    _id;
    _token;
    _artisanPrice;
    _clientPrice;
    _status;
    _artisanId;
    _companyId;
    _suggestionId;
    _currentStep;
    _worksComment;
    _quotationAppointmentAt;
    _worksAppointmentAt;
    _orderId;
    _quotationId;
    _documentsId;


    getId() {
        return this._id;
    }

    getToken() {
        return this._token;
    }

    getArtisanPrice() {
        return this._artisanPrice;
    }

    getClientPrice() {
        return this._clientPrice;
    }

    getStatus() {
        return this._status;
    }

    getArtisanId() {
        return this._artisanId;
    }

    getCompanyId() {
        return this._companyId;
    }

    getSuggestionId() {
        return this._suggestionId;
    }

    getCurrentStep() {
        return this._currentStep;
    }

    getWorksComment() {
        return this._worksComment;
    }

    getQuotationAppointmentAt() {
        return this._quotationAppointmentAt;
    }

    getWorksAppointmentAt() {
        return this._worksAppointmentAt;
    }

    getOrderId() {
        return this._orderId;
    }

    getQuotationId() {
        return this._quotationId;
    }

    getDocumentsId() {
        return this._documentsId;
    }

    getClassName() {
        return "intervention";
    }
}
